import $ from "jquery";

// Function to handle menu toggling
function toggleMenu() {
  $(".js-toggle-menu").on("click", function (e) {
    e.preventDefault();
    $("body").toggleClass("noscroll");
    $("body").toggleClass("menu-active");

    const isExpanded = $("body").hasClass("menu-active");
    $(this).attr("aria-expanded", isExpanded);
  });

  // Sätt initialt värde om menyn börjar stängd
  $(".js-toggle-menu").attr("aria-expanded", "false");
}

// Function to handle menu item clicks
function handleMenuItemClick() {
  const menu = $(".menu");
  $(document).on(
    {
      click: function (e) {
        if (!menu.is(e.target) && menu.has(e.target).length === 0) {
          $(".menu__link")
            .removeClass("menu__link--active")
            .attr("aria-expanded", "false");
        }
      },
    },
    ":not(.menu)",
  );
}

// Function to handle toggling children
function toggleChildren() {
  $(".js-toggle-children").on("click", function (e) {
    const target = e.currentTarget;
    if ($(target).attr("href") === "#") {
      e.preventDefault();
      $(".menu__link")
        .not(target)
        .removeClass("menu__link--active")
        .attr("aria-expanded", "false");

      const isExpanded = !$(target).hasClass("menu__link--active");
      $(target).toggleClass("menu__link--active");
      $(target).attr("aria-expanded", isExpanded);
    }
  });

  // Sätt initialt värde på alla länkar med js-toggle-children
  $(".js-toggle-children").attr("aria-expanded", "false");
}

// Export the functions
export { toggleMenu, handleMenuItemClick, toggleChildren };
